/* eslint no-console: 0 */

import Vue from 'vue'
import Lodges from '../lodges.vue'

document.addEventListener('DOMContentLoaded', () => {
  const el = document.querySelector("#lodges");
  const app = new Vue({
    el,
    render(h){
      return h(Lodges, {
        props: {
            url: el.dataset.url,
            park: JSON.parse(el.dataset.park),
            initfilter: JSON.parse(el.dataset.filter),
            images: JSON.parse(el.dataset.images)
        }
      });
    }
  });
});
